import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Chip } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  root: {
    fontWeight: "600",
    color: "white",
    backgroundColor: theme.palette.inactive.main,
  },
}))

const InactiveChip = ({ className }) => {
  const classes = useStyles()

  return <Chip label="Inactive" classes={classes} className={className} size="small" />
}

export { InactiveChip }
